import * as types from '../actions';

export default function(state = [], action) {
  const response = action.response;

  switch(action.type) {
    case types.DATA_DSDANGCHO_SUCCESS:
      return { ...state, response };
    case types.DATA_DSDANGCHO_ERROR:
      return { ...state, response };
    default:
      return state;
  }
};